export default __webpack_public_path__ + "static/media/tab_credit_card_active.9de1f9ae.svg";